import Vue from "vue";
import Vuex from "vuex";

import auth from "./modules/auth";
import analytics from "./modules/analytics";
import customization from "./modules/customization";
import subscriptions from "./modules/subscriptions";
import subscriptionDetail from "./modules/subscriptionDetail";
import availableProducts from "./modules/availableProducts";
import paymentMethod from "./modules/paymentMethod";
import modals from "./modules/modals";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
	modules: {
		auth,
		analytics,
		customization,
		subscriptions,
		subscriptionDetail,
		availableProducts,
		paymentMethod,
		modals
	},

	strict: debug,

	plugins: [],

	state: {
		isMobile: false,
		loading: false,
		erro_token: false
	},

	mutations: {
		setIsMobile(state, content) {
			state.isMobile = content;
		},

		setLoading(state, content) {
			state.loading = content;
		},

		setErroToken(state, content) {
			state.erro_token = content;
		}
	},
	
	getters: {
		getIsMobile(state){
			return state.isMobile;
		},

		getLoading(state){
			return state.loading;
		},

		getErroToken(state){
			return state.erro_token;
		}
	}
})